import { render, staticRenderFns } from "./exerciseModal.vue?vue&type=template&id=46c89d2e&scoped=true&"
import script from "./exerciseModal.vue?vue&type=script&lang=js&"
export * from "./exerciseModal.vue?vue&type=script&lang=js&"
import style0 from "./exerciseModal.vue?vue&type=style&index=0&id=46c89d2e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c89d2e",
  null
  
)

export default component.exports